import * as Sentry from '@sentry/vue';

// 把Sentry对象暴露到window上
// 从而可以在window.onerror中使用Sentry上报异常
// 禁止在业务代码中使用window.Sentry
// 必须通过全局log服务来上报异常
window.Sentry = Sentry;

export default Sentry;
